import logger from '@/utils/logger'

const KYC_TOKEN = 'tamara-kyc-token'

const getKycTokenFromSessionStorage = () => {
  try {
    return window.sessionStorage.getItem(KYC_TOKEN)
  } catch (error) {
    logger.error(error, {}, { category: 'sessionStorage' })
  }
}

const setKycTokenToSessionStorage = (value) => {
  try {
    window.sessionStorage.setItem(KYC_TOKEN, value)
  } catch (error) {
    logger.error(error, {}, { category: 'sessionStorage' })
  }
}

export { getKycTokenFromSessionStorage, setKycTokenToSessionStorage }
